/*
 * @Author: gaobin
 * @Date: 2025-01-14 17:07:53
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-28 14:31:24
 * @Description: 常量
 */
import { i18n, LANGUAGE_CODE } from '@/locale';

const { t } = i18n.global;

const TIMEOUT = 25000;

// 当前平台 sharer club
const CUR_PLATFORM = 15;

const ENUM_CURRENCY = {
  CNY: 'CNY', // "人民币"
  USD: 'USD', // "美元"
  EUR: 'EUR', // "欧元"
  GBP: 'GBP', // "英镑"
  HKD: 'HKD', // "港币"
  MOP: 'MOP', // "澳门币"
  JPY: 'JPY', // "日元"
  AUD: 'AUD', // "澳大利亚元"
  CAD: 'CAD', // "加拿大元"
  SGD: 'SGD', // "新加坡元"
  THB: 'THB', // "泰铢"
  KRW: 'KRW', // "韩元"
  TWD: 'TWD', // "台币"
  CHF: 'CHF', // "瑞士法郎"
  SEK: 'SEK', // "瑞典克朗"
  DKK: 'DKK', // "丹麦克朗"
  NOK: 'NOK', // "挪威克朗"
  MYR: 'MYR', // "马来西亚林吉特"
  RUB: 'RUB', // "俄罗斯卢布"
  NZD: 'NZD', // "新西兰元"
  ZAR: 'ZAR', // "南非兰特"
  AED: 'AED', // "阿联酋迪拉姆"
  BRL: 'BRL', // "巴西雷亚尔"
  IDR: 'IDR', // "印尼盾"
  INR: 'INR', // "印度卢比"
  PHP: 'PHP', // "菲律宾比索"
  SAR: 'SAR', // "沙特里亚尔"
  TRY: 'TRY', // "土耳其里拉"
};

const LANGUAGE_LIST = [
  {
    lang: LANGUAGE_CODE.en,
    name: t('language.en'),
    currency: 'SAR',
  },
  {
    lang: LANGUAGE_CODE.ar,
    name: t('language.ar'),
    currency: 'ر.س',
  },
];

const ENUM_JUMP_TYPE = {
  TYPE_KEEP_CURRENT_JUMP: 0, // 保留当前页跳转
  TYPE_CLEAR_CURRENT_JUMP: 1, // 清除当前页跳转
  TYPE_CLEAR_ALL_JUMP: 2, // 清除所有跳转
  TYPE_GO_TO_TABBAR_JUMP: 3, // 跳转到tabBar方式
  TYPE_EXTERNAL_LINK_JUMP: 4, // 外部链接跳转
};

const ENUM_UPLOAD_SCENE = {
  USER_AVATAR: 'userAvatar', // 用户头像
};

const ANDROID_PERMISSION_LIST = {
  NOTIFICATION: 'android.permission.POST_NOTIFICATIONS', // 通知权限
  ALBUM: 'android.permission.READ_EXTERNAL_STORAGE', // 相册权限
  CAMERA: 'android.permission.CAMERA', // 相机权限
  MICROPHONE: 'android.permission.RECORD_AUDIO', // 麦克风权限
  LOCATION: 'android.permission.ACCESS_FINE_LOCATION', // 定位权限
};

/**
 * 海外运费支付状态
 */
const ENUM_PAY_STATUS = {
  OVERSEAS_AMOUNT_EXAMINE: 9, // 海外运费审核中
  OVERSEAS_AMOUNT_EXAMINE_SUCCESS: 10, // 海外运费审核成功
  OVERSEAS_AMOUNT_EXAMINE_ERROR: 11, // 海外运费审核失败
};

const ENUM_BUSINESS_TYPE = {
  HELLO: 1, // hello 业务线
  SHARE_CLUB: 3, // shareClub 业务线
  UWB_USD_IQD: 99, // uwebuy 美元转第纳尔汇率
};

/**
 * 订单状态
 */
const ENUM_ORDER_STATUS = {
  // 待付款
  WAIT_BUYER_PAY: 1, // 等待买家付款,

  // 待发货
  WAITING_PURCHASE: 14, // 待采购,
  WAIT_SELLER_SEND: 2, // 等待卖家发货,

  // 取消
  CANCEL: 7, // 交易取消,

  // 已收货
  CONFIRM_GOODS: 5, // 已收货,

  // 待收货
  CHINA_SHIPPING: 9, // 中国段已发货,
  LOGISTICS_PAYMENT: 10, // 海运物流费付款,
  SEA_SHIPPING: 11, // 海运发货,
  TO_WAREHOUSE: 12, // 货品到仓,

  // 无用的状态
  WAIT_BUYER_RECEIVER: 3, // 等待买家收货,
  CONFIRM_GOODS_AND_HAS_SUBSIDY: 4, // 确认收货,
  SUCCESS: 6, // 交易成功,
  TERMINATED: 8, // 交易中止,
};

const ENUM_ORDER_STATUS_DESC = {
  [ENUM_ORDER_STATUS.WAIT_BUYER_PAY]: t('awaitingPay'),

  [ENUM_ORDER_STATUS.WAIT_SELLER_SEND]: t('waitDelivery'),
  [ENUM_ORDER_STATUS.WAITING_PURCHASE]: t('waitDelivery'),

  [ENUM_ORDER_STATUS.CONFIRM_GOODS]: t('receivedGoods'),

  [ENUM_ORDER_STATUS.CANCEL]: t('cancelled'),

  [ENUM_ORDER_STATUS.CHINA_SHIPPING]: t('waitingForReceipt'),
  [ENUM_ORDER_STATUS.LOGISTICS_PAYMENT]: t('waitingForReceipt'),
  [ENUM_ORDER_STATUS.SEA_SHIPPING]: t('waitingForReceipt'),
  [ENUM_ORDER_STATUS.TO_WAREHOUSE]: t('waitingForReceipt'),
};

const ENUM_INQUIRY_STATUS = {
  WAIT: 1, // 待处理
  SUCCESS: 2, // 询单成功
  ERROR: 3, // 询单失败
};

// inquire status
const INQUIRY_STATUS_LEST = [
  {
    value: '',
    name: t('quanBu'),
    id: 'all',
  },
  {
    value: ENUM_INQUIRY_STATUS.WAIT,
    name: t('pending'),
    id: 'wait',
  },
  {
    value: ENUM_INQUIRY_STATUS.SUCCESS,
    name: t('success'),
    id: 'success',
  },
  {
    value: ENUM_INQUIRY_STATUS.ERROR,
    name: t('failed'),
    id: 'err',
  },
];

// order status
const ORDER_STATUS_LIST = [
  {
    value: '',
    name: t('allOrders'),
    id: 'allOrders',
  },
  {
    value: ENUM_ORDER_STATUS.WAIT_BUYER_PAY,
    name: t('awaitingPay'),
    id: 'awaitingPay',
  },
  {
    value: ENUM_ORDER_STATUS.WAIT_SELLER_SEND,
    name: t('waitDelivery'),
    id: 'waitDelivery',
  },
  {
    value: ENUM_ORDER_STATUS.WAIT_BUYER_RECEIVER,
    name: t('waitingForReceipt'),
    id: 'logisti',
  },
  {
    value: ENUM_ORDER_STATUS.CONFIRM_GOODS,
    name: t('receivedGoods'),
    id: 'confirmGoods',
  },
  // 已取消
  {
    value: ENUM_ORDER_STATUS.CANCEL,
    name: t('cancelled'),
    id: 'cancel',
  },
];

/**
 * 支付方式
 */
const PAYMENT_TYPE_ENUM = {
  ONLINE_PAYMENT: 1, // 在线支付
  OFFLINE_ACCOUNT: 2, // 线下支付
  OFFLINE_CASH: 3, // 线下现金支付
};

const PAYMENT_TYPE_NAME = {
  [PAYMENT_TYPE_ENUM.ONLINE_PAYMENT]: t('onlinePayment'), // 在线支付
  [PAYMENT_TYPE_ENUM.OFFLINE_ACCOUNT]: t('bankTransfer'), // 线下支付
  [PAYMENT_TYPE_ENUM.OFFLINE_CASH]: t('cashPayment'), // 线下现金支付
};

/**
 * 当前分享券的值
 */
const CUR_SHARE_COUPON_VALUE = 5;

export {
  ANDROID_PERMISSION_LIST,
  CUR_PLATFORM,
  CUR_SHARE_COUPON_VALUE,
  ENUM_BUSINESS_TYPE,
  ENUM_CURRENCY,
  ENUM_JUMP_TYPE,
  ENUM_ORDER_STATUS,
  ENUM_ORDER_STATUS_DESC,
  ENUM_PAY_STATUS,
  ENUM_UPLOAD_SCENE,
  INQUIRY_STATUS_LEST,
  LANGUAGE_LIST,
  ORDER_STATUS_LIST,
  PAYMENT_TYPE_NAME,
  TIMEOUT,
};
